import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'

const NavbarActionsContext = createContext<{
  setNavbarActions: (node: ReactNode) => void
  navbarActions: ReactNode
}>({
  setNavbarActions: () => {},
  navbarActions: null,
})

export function NavbarActionsProvider({ children }: { children: ReactNode }) {
  const [navbarActions, setNavbarActions] = useState<ReactNode>(null)
  return (
    <NavbarActionsContext.Provider value={{ navbarActions, setNavbarActions }}>
      {children}
    </NavbarActionsContext.Provider>
  )
}

export function useNavbarActions() {
  return useContext(NavbarActionsContext)
}
